<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">


      <a-form-model-item prop="userName" >
        <span slot="label" >
          <a-tooltip>
            用户昵称<template slot="title">用户昵称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userName" :maxLength="100" :placeholder="$t('请输入')+'用户昵称'" />
      </a-form-model-item>
      <a-form-model-item prop="submitContent" >
        <span slot="label" >
          <a-tooltip>
            提交的内容说明<template slot="title">提交的内容说明</template>
          </a-tooltip>
        </span>
        <editor v-model="form.submitContent" />
      </a-form-model-item>
      <a-form-model-item prop="rewardPoints" >
        <span slot="label" >
          <a-tooltip>
            获得的积分数量<template slot="title">获得的积分数量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.rewardPoints"  :placeholder="$t('请输入')+'获得的积分数量'" />
      </a-form-model-item>
      <a-form-model-item prop="submitTime" >
        <span slot="label" >
          <a-tooltip>
            提交时间<template slot="title">提交时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.submitTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="auditStatus" >
        <span slot="label" >
          <a-tooltip>
            审核状态 0=待审核 1=审核通过 2=审核拒绝<template slot="title">审核状态 0=待审核 1=审核通过 2=审核拒绝</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="auditRemark" >
        <span slot="label" >
          <a-tooltip>
            审核备注<template slot="title">审核备注</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.auditRemark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="auditor" >
        <span slot="label" >
          <a-tooltip>
            审核人<template slot="title">审核人</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.auditor"  :placeholder="$t('请输入')+'审核人'" />
      </a-form-model-item>
      <a-form-model-item prop="auditTime" >
        <span slot="label" >
          <a-tooltip>
            审核时间<template slot="title">审核时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.auditTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTaskSubmit, addTaskSubmit, updateTaskSubmit } from '@/api/task/taskSubmit'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";

import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        taskId: null,

        userId: null,

        userName: null,

        submitContent: null,

        rewardPoints: null,

        submitTime: null,

        auditStatus: 0,

        auditRemark: null,

        auditor: null,

        auditTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        taskId: [
          { required: true, message: '任务ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        submitTime: [
          { required: true, message: '提交时间'+this.$t('不能为空'), trigger: 'blur' }
        ],
        auditStatus: [
          { required: true, message: '审核状态 0=待审核 1=审核通过 2=审核拒绝'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        taskId: null,
        userId: null,
        userName: null,
        submitContent: null,
        rewardPoints: null,
        submitTime: null,
        auditStatus: 0,
        auditRemark: null,
        auditor: null,
        auditTime: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTaskSubmit({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateTaskSubmit(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addTaskSubmit(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
